import { render, staticRenderFns } from "./Momentum.vue?vue&type=template&id=5d69967a&scoped=true"
import script from "./Momentum.vue?vue&type=script&lang=js"
export * from "./Momentum.vue?vue&type=script&lang=js"
import style0 from "./Momentum.vue?vue&type=style&index=0&id=5d69967a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d69967a",
  null
  
)

export default component.exports